import React from 'react';

export default function IconWitdrawal() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.625 16.5645H6.625C5.8 16.5645 5.125 15.8895 5.125 15.0645V9.06445C5.125 8.23945 5.8 7.56445 6.625 7.56445H18.625C19.45 7.56445 20.125 8.23945 20.125 9.06445V15.0645C20.125 15.8895 19.45 16.5645 18.625 16.5645H15.625"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.625 14.3145C13.8676 14.3145 14.875 13.3071 14.875 12.0645C14.875 10.8218 13.8676 9.81445 12.625 9.81445C11.3824 9.81445 10.375 10.8218 10.375 12.0645C10.375 13.3071 11.3824 14.3145 12.625 14.3145Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.625 16.3145V20.0645"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.125 18.5645L12.625 20.0645L14.125 18.5645"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
